import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { type AgentActionTag } from 'entities/AgentActions'
import { TagsControl } from 'entities/Tags'

export class AgentActionTagStore {
  readonly store: TagsControl
  private readonly _disposeIds: IReactionDisposer | null = null

  constructor(private _model: AgentActionTag) {
    this.store = new TagsControl(_model.tagIds)

    makeAutoObservable(this)

    this._disposeIds = reaction(
      () => this.store.ids,
      (ids) => this._model.syncIds(ids)
    )
  }

  dispose = () => {
    this._disposeIds?.()
  }
}
